import React, { useEffect, useRef, useState } from "react";
import arrowR from "./../assets/arrowR.png";
import arrowL from "./../assets/arrowL.png";

const Step2 = ({
  currentManagerIndex,
  answers,
  handleRangeChange,
  selectedManagers,
  setCurrentStep,
  setCurrentManagerIndex,
  t,
  lang
}) => {
  const currentManager = selectedManagers[currentManagerIndex];
  const rangeSteps = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const step2Ref = useRef(null);
  const [isActive, setIsActive] = useState(false); // <-- stato per abilitare scroll

  console.log(currentManager.questions)
  // Abilita lo scroll dopo la prima interazione
  useEffect(() => {
    if (currentManagerIndex > 0 || selectedManagers.length > 1) {
      setIsActive(true);
    }
  }, [currentManagerIndex, selectedManagers]);

  return (
    <div ref={step2Ref}>
      {/* Sezione intestazione manager */}
      <div
        className="manager-header"
        style={{ borderColor: currentManager.color }}
      >
        <img
          src={currentManager.images.card[lang]}
          alt={currentManager.name}
          className="bannerManager"
        />
      </div>

      <h1 className="h1Config">{t.titleStep2}</h1>
      <p className="subTitle">{t.subtitleStep2}</p>

      {currentManager.questions.map((question, index) => (
        <div
          key={index}
          className="question-container"
          style={{ borderColor: currentManager.color, padding: "20px" }}
        >
          <div className="question-text">{question[lang]}</div>
          <div className="range-wrapper">
            <div className="numberOverRange">
              {rangeSteps.map((step) => (
                <span key={step} style={{ textAlign: "center", width: "20px" }}>
                  {step}
                </span>
              ))}
            </div>

            <input
              className="inputRange"
              type="range"
              min="0"
              max="10"
              step="1"
              value={answers[currentManager.id]?.[question.id] || 5}
              onChange={(e) =>
                handleRangeChange(currentManager.id, question.id, e.target.value, e)
              }
              style={{
                "--slider-color": currentManager.color,
                "--progress": `${((answers[currentManager.id]?.[question.id] || 5) / 10) * 100}%`,
              }}
            />
          </div>
        </div>
      ))}

      <div className="navigation-buttons button-container">
        <button onClick={() => setCurrentStep(1)}>
          <img src={arrowL} alt="Freccia sinistra" /> {t.indietro}
        </button>

        {currentManagerIndex < selectedManagers.length - 1 ? (
          <button
            onClick={() => {
              setCurrentManagerIndex((prev) => {
                const nextIndex = prev + 1;
                // Scroll solo dopo che l'indice è cambiato
                setTimeout(() => {
                  if (step2Ref.current) {
                    step2Ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
                  }
                }, 0); // Dopo il re-render
                return nextIndex;
              });
            }}
          >
            {t.avanti} <img src={arrowR} alt="Freccia destra" />
          </button>
        ) : (
          <button
            onClick={() => {
              // Scrolla in alto prima di cambiare step, se vuoi
              setCurrentStep(3);
            }}
          >
            {t.avanti} <img src={arrowR} alt="Freccia destra" />
          </button>
        )}
      </div>
    </div>
  );
};

export default Step2;
